import { Autoplay, Navigation, Pagination, Keyboard, EffectFade, Mousewheel } from "swiper";

export default function getImageTextSliderOptions(slidesPerView: number, space: number | null = null) {
  const options = {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    slidesPerView: 1,
    spaceBetween: space !== null ? space : 30,
    grabCursor: true,
    speed: 1500,
    pagination: {
      el: ".image-swiper-pagination",
      clickable: true,
      type: "bullets",
    },
    autoplay: false,
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: slidesPerView === 3 ? 2 : slidesPerView,
        spaceBetween: 60,
      },
      1024: {
        slidesPerView: slidesPerView === 3 ? 2 : slidesPerView,
        spaceBetween: 85,
      },
      1400: {
        slidesPerView: slidesPerView,
        spaceBetween: 85,
      }
    },
  }
  return options;
}
